<template>
    <div id="account_detail">
        <bill-item :list="list" v-if="list.length > 0" />
        <infinite-loading :identifier="infiniteId" @infinite="infiniteHandler">
            <div slot="no-more" class="end">资金流水记录结束</div>
            <div slot="no-results" class="end">暂无资金流水记录</div>
            <div slot="error" class="end" slot-scope="{ trigger }">
                出错了，请刷新&nbsp;&nbsp;<a class="here" href="javascript:;" @click="refresh">here</a>
            </div>
        </infinite-loading>
    </div>
</template>
<script>
    import { debounce } from 'riku-verycloud'
    import InfiniteLoading from "vue-infinite-loading";
    export default {
        components: {
            InfiniteLoading,
        },
        data() {
            return {
                show: false,
                rawList: [],
                list: [],
                page: 1,
                page_size: 10,
                totalPage: 1,
                loading: 0,
                infiniteId: 1,
            };
        },
        mounted() {},
        methods: {
            addDate(list) {
                const groupedArray = list.reduce((acc, curr) => {
                    // 将 "ctime" 字段转换为日期对象
                    const date = curr.ctime.substring(0, 10);
                    // 搜索已有的分组中是否有与当前日期相同的分组，
                    // 如果有则将当前数据加入该分组，
                    // 如果没有则新建一个分组并加入当前数据
                    const existingGroup = acc.find(
                        (group) => group.date == date
                    );
                    if (existingGroup) {
                        existingGroup.data.push(curr);
                    } else {
                        acc.push({
                            date: date,
                            weekDay: new Date(date).getDay(),
                            data: [curr],
                        });
                    }
                    return acc;
                }, []);
                return groupedArray;
            },
            infiniteHandler: debounce(function ($state) {
                this.loading++;
                this.$Ajax('wallet/bill', { page: this.page, page_size: this.page_size }, 'get').then(rs => {
                    this.show = true
                    if (rs.code != 200 || !rs.data) {
                        $state.complete()
                        return
                    }
                    const nextList = rs.data.list instanceof Array ? rs.data.list : []
                    const totalPage = Number(rs.data.totalPage) || 1
                    this.totalPage = totalPage
                    if (nextList.length > 0) {
                        this.rawList.push(...nextList)
                        this.list = this.addDate(this.rawList)
                        this.page++
                        $state.loaded()
                    }
                    if (nextList.length === 0 || this.page > this.totalPage) {
                        $state.complete()
                    }
                }).catch(() => {
                    this.show = true
                    $state.error()
                }).finally(() => {
                    this.loading--;
                })
            }),
            refresh() {
                this.show = false
                this.page = 1
                this.totalPage = 1
                this.rawList = []
                this.list = []
                this.infiniteId++
            },
        },
    };
</script>
<style lang="less" scoped>
.end {
    text-align: center;
    margin: 2rem 0;
    color: #aaa;
    .here {
        color: var(--theme);
    }
}
#account_detail {
    padding-top: 1rem;
}
</style>
